import { render, staticRenderFns } from "./alo-timeago.vue?vue&type=template&id=3902bada"
import script from "./alo-timeago.vue?vue&type=script&lang=js"
export * from "./alo-timeago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports